"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNIVERSAL_COUNTRIES = exports.COVER_GENIUS_COUNTRIES = exports.ALLOWED_CFMR_ORIGIN_COUNTRIES = exports.ALLOWED_ORIGIN_COUNTRIES = void 0;
exports.ALLOWED_ORIGIN_COUNTRIES = ["NZ", "AU", "SG", "MY", "TH", "IN", "HK"];
exports.ALLOWED_CFMR_ORIGIN_COUNTRIES = ["AU", "NZ", "SG", "US", "GB", "CA", "VN", "AE", "SA", "QA", "FR", "DE", "IE", "IT", "ES", "NL"];
exports.COVER_GENIUS_COUNTRIES = [
    {
        name: "Australia",
        code: "Australia",
        country_code: "AUS",
        two_letter_country_code: "AU",
    },
];
exports.UNIVERSAL_COUNTRIES = [
    {
        name: "Aruba",
        code: "Aruba",
        country_code: "ABW",
        two_letter_country_code: "AW",
    },
    {
        name: "Angola",
        code: "Angola",
        country_code: "AGO",
        two_letter_country_code: "AO",
    },
    {
        name: "Anguilla",
        code: "Anguilla",
        country_code: "AIA",
        two_letter_country_code: "AI",
    },
    {
        name: "Åland Islands",
        code: "Åland Islands",
        country_code: "ALA",
        two_letter_country_code: "AX",
    },
    {
        name: "Albania",
        code: "Albania",
        country_code: "ALB",
        two_letter_country_code: "AL",
    },
    {
        name: "Andorra",
        code: "Andorra",
        country_code: "AND",
        two_letter_country_code: "AD",
    },
    {
        name: "Netherlands Antilles",
        code: "Netherlands Antilles",
        country_code: "ANT",
        two_letter_country_code: "AN",
    },
    {
        name: "United Arab Emirates",
        code: "United Arab Emirates",
        country_code: "ARE",
        two_letter_country_code: "AE",
    },
    {
        name: "Argentina",
        code: "Argentina",
        country_code: "ARG",
        two_letter_country_code: "AR",
    },
    {
        name: "Armenia",
        code: "Armenia",
        country_code: "ARM",
        two_letter_country_code: "AM",
    },
    {
        name: "American Samoa",
        code: "American Samoa",
        country_code: "ASM",
        two_letter_country_code: "AS",
    },
    {
        name: "Antarctica",
        code: "Antarctica",
        country_code: "ATA",
        two_letter_country_code: "AQ",
    },
    {
        name: "Antigua and Barbuda",
        code: "Antigua and Barbuda",
        country_code: "ATG",
        two_letter_country_code: "AG",
    },
    {
        name: "Austria",
        code: "Austria",
        country_code: "AUT",
        two_letter_country_code: "AT",
    },
    {
        name: "Australian Waters (cruises)",
        code: "Australian Waters",
        country_code: "AUW",
        two_letter_country_code: "AU",
    },
    {
        name: "Azerbaijan",
        code: "Azerbaijan",
        country_code: "AZE",
        two_letter_country_code: "AZ",
    },
    {
        name: "Belgium",
        code: "Belgium",
        country_code: "BEL",
        two_letter_country_code: "BE",
    },
    {
        name: "Benin",
        code: "Benin",
        country_code: "BEN",
        two_letter_country_code: "BJ",
    },
    {
        name: "Burkina Faso",
        code: "Burkina Faso",
        country_code: "BFA",
        two_letter_country_code: "BF",
    },
    {
        name: "Bangladesh",
        code: "Bangladesh",
        country_code: "BGD",
        two_letter_country_code: "BD",
    },
    {
        name: "Bulgaria",
        code: "Bulgaria",
        country_code: "BGR",
        two_letter_country_code: "BG",
    },
    {
        name: "Bahrain",
        code: "Bahrain",
        country_code: "BHR",
        two_letter_country_code: "BH",
    },
    {
        name: "Bahamas",
        code: "Bahamas",
        country_code: "BHS",
        two_letter_country_code: "BS",
    },
    {
        name: "Bosnia and Herzegovina",
        code: "Bosnia and Herzegovina",
        country_code: "BIH",
        two_letter_country_code: "BA",
    },
    {
        name: "Saint Barthélemy",
        code: "Saint Barthélemy",
        country_code: "BLM",
        two_letter_country_code: "BL",
    },
    {
        name: "Belarus",
        code: "Belarus",
        country_code: "BLR",
        two_letter_country_code: "BY",
    },
    {
        name: "Belize",
        code: "Belize",
        country_code: "BLZ",
        two_letter_country_code: "BZ",
    },
    {
        name: "Bermuda",
        code: "Bermuda",
        country_code: "BMU",
        two_letter_country_code: "BM",
    },
    {
        name: "Bolivia",
        code: "Bolivia",
        country_code: "BOL",
        two_letter_country_code: "BO",
    },
    {
        name: "Brazil",
        code: "Brazil",
        country_code: "BRA",
        two_letter_country_code: "BR",
    },
    {
        name: "Barbados",
        code: "Barbados",
        country_code: "BRB",
        two_letter_country_code: "BB",
    },
    {
        name: "Brunei Darussalam",
        code: "Brunei Darussalam",
        country_code: "BRN",
        two_letter_country_code: "BN",
    },
    {
        name: "Bhutan",
        code: "Bhutan",
        country_code: "BTN",
        two_letter_country_code: "BT",
    },
    {
        name: "Bouvet Island",
        code: "Bouvet Island",
        country_code: "BVT",
        two_letter_country_code: "BV",
    },
    {
        name: "Botswana",
        code: "Botswana",
        country_code: "BWA",
        two_letter_country_code: "BW",
    },
    {
        name: "Canada",
        code: "Canada",
        country_code: "CAN",
        two_letter_country_code: "CA",
    },
    {
        name: "Cocos (Keeling) Islands",
        code: "Cocos (Keeling) Islands",
        country_code: "CCK",
        two_letter_country_code: "CC",
    },
    {
        name: "Switzerland",
        code: "Switzerland",
        country_code: "CHE",
        two_letter_country_code: "CH",
    },
    {
        name: "Chile",
        code: "Chile",
        country_code: "CHL",
        two_letter_country_code: "CL",
    },
    {
        name: "Côte d'Ivoire",
        code: "Côte d'Ivoire",
        country_code: "CIV",
        two_letter_country_code: "CI",
    },
    {
        name: "Cameroon",
        code: "Cameroon",
        country_code: "CMR",
        two_letter_country_code: "CM",
    },
    {
        name: "Democratic Republic of the Congo",
        code: "Democratic Republic of the Congo",
        country_code: "COD",
        two_letter_country_code: "CD",
    },
    {
        name: "Congo",
        code: "Congo",
        country_code: "COG",
        two_letter_country_code: "CG",
    },
    {
        name: "Cook Islands",
        code: "Cook Islands",
        country_code: "COK",
        two_letter_country_code: "CK",
    },
    {
        name: "Colombia",
        code: "Colombia",
        country_code: "COL",
        two_letter_country_code: "CO",
    },
    {
        name: "Comoros",
        code: "Comoros",
        country_code: "COM",
        two_letter_country_code: "KM",
    },
    {
        name: "Cape Verde",
        code: "Cape Verde",
        country_code: "CPV",
        two_letter_country_code: "CV",
    },
    {
        name: "Costa Rica",
        code: "Costa Rica",
        country_code: "CRI",
        two_letter_country_code: "CR",
    },
    {
        name: "Cuba",
        code: "Cuba",
        country_code: "CUB",
        two_letter_country_code: "CU",
    },
    {
        name: "Christmas Island",
        code: "Christmas Island",
        country_code: "CXR",
        two_letter_country_code: "CX",
    },
    {
        name: "Cayman Islands",
        code: "Cayman Islands",
        country_code: "CYM",
        two_letter_country_code: "KY",
    },
    {
        name: "Cyprus",
        code: "Cyprus",
        country_code: "CYP",
        two_letter_country_code: "CY",
    },
    {
        name: "Czech Republic",
        code: "Czech Republic",
        country_code: "CZE",
        two_letter_country_code: "CZ",
    },
    {
        name: "Germany",
        code: "Germany",
        country_code: "DEU",
        two_letter_country_code: "DE",
    },
    {
        name: "Djibouti",
        code: "Djibouti",
        country_code: "DJI",
        two_letter_country_code: "DJ",
    },
    {
        name: "Dominica",
        code: "Dominica",
        country_code: "DMA",
        two_letter_country_code: "DM",
    },
    {
        name: "Denmark",
        code: "Denmark",
        country_code: "DNK",
        two_letter_country_code: "DK",
    },
    {
        name: "Dominican Republic",
        code: "Dominican Republic",
        country_code: "DOM",
        two_letter_country_code: "DO",
    },
    {
        name: "Algeria",
        code: "Algeria",
        country_code: "DZA",
        two_letter_country_code: "DZ",
    },
    {
        name: "Ecuador",
        code: "Ecuador",
        country_code: "ECU",
        two_letter_country_code: "EC",
    },
    {
        name: "Egypt",
        code: "Egypt",
        country_code: "EGY",
        two_letter_country_code: "EG",
    },
    {
        name: "Eritrea",
        code: "Eritrea",
        country_code: "ERI",
        two_letter_country_code: "ER",
    },
    {
        name: "Western Sahara",
        code: "Western Sahara",
        country_code: "ESH",
        two_letter_country_code: "EH",
    },
    {
        name: "Spain",
        code: "Spain",
        country_code: "ESP",
        two_letter_country_code: "ES",
    },
    {
        name: "Estonia",
        code: "Estonia",
        country_code: "EST",
        two_letter_country_code: "EE",
    },
    {
        name: "Ethiopia",
        code: "Ethiopia",
        country_code: "ETH",
        two_letter_country_code: "ET",
    },
    {
        name: "Finland",
        code: "Finland",
        country_code: "FIN",
        two_letter_country_code: "FI",
    },
    {
        name: "Fiji",
        code: "Fiji",
        country_code: "FJI",
        two_letter_country_code: "FJ",
    },
    {
        name: "Falkland Islands ",
        code: "Falkland Islands ",
        country_code: "FLK",
        two_letter_country_code: "FK",
    },
    {
        name: "France",
        code: "France",
        country_code: "FRA",
        two_letter_country_code: "FR",
    },
    {
        name: "Faroe Islands",
        code: "Faroe Islands",
        country_code: "FRO",
        two_letter_country_code: "FO",
    },
    {
        name: "Micronesia",
        code: "Micronesia",
        country_code: "FSM",
        two_letter_country_code: "FM",
    },
    {
        name: "Gabon",
        code: "Gabon",
        country_code: "GAB",
        two_letter_country_code: "GA",
    },
    {
        name: "United Kingdom",
        code: "United Kingdom",
        country_code: "GBR",
        two_letter_country_code: "GB",
    },
    {
        name: "Georgia",
        code: "Georgia",
        country_code: "GEO",
        two_letter_country_code: "GE",
    },
    {
        name: "Guernsey",
        code: "Guernsey",
        country_code: "GGY",
        two_letter_country_code: "GG",
    },
    {
        name: "Ghana",
        code: "Ghana",
        country_code: "GHA",
        two_letter_country_code: "GH",
    },
    {
        name: "Gibraltar",
        code: "Gibraltar",
        country_code: "GIB",
        two_letter_country_code: "GI",
    },
    {
        name: "Guinea",
        code: "Guinea",
        country_code: "GIN",
        two_letter_country_code: "GN",
    },
    {
        name: "Guadeloupe",
        code: "Guadeloupe",
        country_code: "GLP",
        two_letter_country_code: "GP",
    },
    {
        name: "Gambia",
        code: "Gambia",
        country_code: "GMB",
        two_letter_country_code: "GM",
    },
    {
        name: "Guinea-Bissau",
        code: "Guinea-Bissau",
        country_code: "GNB",
        two_letter_country_code: "GW",
    },
    {
        name: "Equatorial Guinea",
        code: "Equatorial Guinea",
        country_code: "GNQ",
        two_letter_country_code: "GQ",
    },
    {
        name: "Greece",
        code: "Greece",
        country_code: "GRC",
        two_letter_country_code: "GR",
    },
    {
        name: "Grenada",
        code: "Grenada",
        country_code: "GRD",
        two_letter_country_code: "GD",
    },
    {
        name: "Greenland",
        code: "Greenland",
        country_code: "GRL",
        two_letter_country_code: "GL",
    },
    {
        name: "Guatemala",
        code: "Guatemala",
        country_code: "GTM",
        two_letter_country_code: "GT",
    },
    {
        name: "French Guiana",
        code: "French Guiana",
        country_code: "GUF",
        two_letter_country_code: "GF",
    },
    {
        name: "Guam",
        code: "Guam",
        country_code: "GUM",
        two_letter_country_code: "GU",
    },
    {
        name: "Guyana",
        code: "Guyana",
        country_code: "GUY",
        two_letter_country_code: "GY",
    },
    {
        name: "Hong Kong",
        code: "Hong Kong",
        country_code: "HKG",
        two_letter_country_code: "HK",
    },
    {
        name: "Heard Island and McDonald Islands",
        code: "Heard Island and McDonald Islands",
        country_code: "HMD",
        two_letter_country_code: "HM",
    },
    {
        name: "Honduras",
        code: "Honduras",
        country_code: "HND",
        two_letter_country_code: "HN",
    },
    {
        name: "Croatia",
        code: "Croatia",
        country_code: "HRV",
        two_letter_country_code: "HR",
    },
    {
        name: "Haiti",
        code: "Haiti",
        country_code: "HTI",
        two_letter_country_code: "HT",
    },
    {
        name: "Hungary",
        code: "Hungary",
        country_code: "HUN",
        two_letter_country_code: "HU",
    },
    {
        name: "Indonesia",
        code: "Indonesia",
        country_code: "IDN",
        two_letter_country_code: "ID",
    },
    {
        name: "Isle of Man",
        code: "Isle of Man",
        country_code: "IMN",
        two_letter_country_code: "IM",
    },
    {
        name: "India",
        code: "India",
        country_code: "IND",
        two_letter_country_code: "IN",
    },
    {
        name: "British Indian Ocean Territory",
        code: "British Indian Ocean Territory",
        country_code: "IOT",
        two_letter_country_code: "IO",
    },
    {
        name: "Ireland",
        code: "Ireland",
        country_code: "IRL",
        two_letter_country_code: "IE",
    },
    {
        name: "Iceland",
        code: "Iceland",
        country_code: "ISL",
        two_letter_country_code: "IS",
    },
    {
        name: "Israel",
        code: "Israel",
        country_code: "ISR",
        two_letter_country_code: "IL",
    },
    {
        name: "Italy",
        code: "Italy",
        country_code: "ITA",
        two_letter_country_code: "IT",
    },
    {
        name: "Jamaica",
        code: "Jamaica",
        country_code: "JAM",
        two_letter_country_code: "JM",
    },
    {
        name: "Jersey",
        code: "Jersey",
        country_code: "JEY",
        two_letter_country_code: "JE",
    },
    {
        name: "Jordan",
        code: "Jordan",
        country_code: "JOR",
        two_letter_country_code: "JO",
    },
    {
        name: "Japan",
        code: "Japan",
        country_code: "JPN",
        two_letter_country_code: "JP",
    },
    {
        name: "Kazakhstan",
        code: "Kazakhstan",
        country_code: "KAZ",
        two_letter_country_code: "KZ",
    },
    {
        name: "Kenya",
        code: "Kenya",
        country_code: "KEN",
        two_letter_country_code: "KE",
    },
    {
        name: "Kyrgyzstan",
        code: "Kyrgyzstan",
        country_code: "KGZ",
        two_letter_country_code: "KG",
    },
    {
        name: "Cambodia",
        code: "Cambodia",
        country_code: "KHM",
        two_letter_country_code: "KH",
    },
    {
        name: "Kiribati",
        code: "Kiribati",
        country_code: "KIR",
        two_letter_country_code: "KI",
    },
    {
        name: "Saint Kitts and Nevis",
        code: "Saint Kitts and Nevis",
        country_code: "KNA",
        two_letter_country_code: "KN",
    },
    {
        name: "South Korea",
        code: "South Korea",
        country_code: "KOR",
        two_letter_country_code: "KR",
    },
    {
        name: "Kuwait",
        code: "Kuwait",
        country_code: "KWT",
        two_letter_country_code: "KW",
    },
    {
        name: "Laos",
        code: "Laos",
        country_code: "LAO",
        two_letter_country_code: "LA",
    },
    {
        name: "Lebanon",
        code: "Lebanon",
        country_code: "LBN",
        two_letter_country_code: "LB",
    },
    {
        name: "Liberia",
        code: "Liberia",
        country_code: "LBR",
        two_letter_country_code: "LR",
    },
    {
        name: "Saint Lucia",
        code: "Saint Lucia",
        country_code: "LCA",
        two_letter_country_code: "LC",
    },
    {
        name: "Liechtenstein",
        code: "Liechtenstein",
        country_code: "LIE",
        two_letter_country_code: "LI",
    },
    {
        name: "Sri Lanka",
        code: "Sri Lanka",
        country_code: "LKA",
        two_letter_country_code: "LK",
    },
    {
        name: "Lesotho",
        code: "Lesotho",
        country_code: "LSO",
        two_letter_country_code: "LS",
    },
    {
        name: "Lithuania",
        code: "Lithuania",
        country_code: "LTU",
        two_letter_country_code: "LT",
    },
    {
        name: "Luxembourg",
        code: "Luxembourg",
        country_code: "LUX",
        two_letter_country_code: "LU",
    },
    {
        name: "Latvia",
        code: "Latvia",
        country_code: "LVA",
        two_letter_country_code: "LV",
    },
    {
        name: "Macao",
        code: "Macao",
        country_code: "MAC",
        two_letter_country_code: "MO",
    },
    {
        name: "Saint Martin (French part)",
        code: "Saint Martin (French part)",
        country_code: "MAF",
        two_letter_country_code: "MF",
    },
    {
        name: "Morocco",
        code: "Morocco",
        country_code: "MAR",
        two_letter_country_code: "MA",
    },
    {
        name: "Monaco",
        code: "Monaco",
        country_code: "MCO",
        two_letter_country_code: "MC",
    },
    {
        name: "Moldova",
        code: "Moldova",
        country_code: "MDA",
        two_letter_country_code: "MD",
    },
    {
        name: "Madagascar",
        code: "Madagascar",
        country_code: "MDG",
        two_letter_country_code: "MG",
    },
    {
        name: "Maldives",
        code: "Maldives",
        country_code: "MDV",
        two_letter_country_code: "MV",
    },
    {
        name: "Mexico",
        code: "Mexico",
        country_code: "MEX",
        two_letter_country_code: "MX",
    },
    {
        name: "Marshall Islands",
        code: "Marshall Islands",
        country_code: "MHL",
        two_letter_country_code: "MH",
    },
    {
        name: "Macedonia",
        code: "Macedonia",
        country_code: "MKD",
        two_letter_country_code: "MK",
    },
    {
        name: "Malta",
        code: "Malta",
        country_code: "MLT",
        two_letter_country_code: "MT",
    },
    {
        name: "Myanmar",
        code: "Myanmar",
        country_code: "MMR",
        two_letter_country_code: "MM",
    },
    {
        name: "Montenegro",
        code: "Montenegro",
        country_code: "MNE",
        two_letter_country_code: "ME",
    },
    {
        name: "Mongolia",
        code: "Mongolia",
        country_code: "MNG",
        two_letter_country_code: "MN",
    },
    {
        name: "Northern Mariana Islands",
        code: "Northern Mariana Islands",
        country_code: "MNP",
        two_letter_country_code: "MP",
    },
    {
        name: "Mozambique",
        code: "Mozambique",
        country_code: "MOZ",
        two_letter_country_code: "MZ",
    },
    {
        name: "Mauritania",
        code: "Mauritania",
        country_code: "MRT",
        two_letter_country_code: "MR",
    },
    {
        name: "Montserrat",
        code: "Montserrat",
        country_code: "MSR",
        two_letter_country_code: "MS",
    },
    {
        name: "Martinique",
        code: "Martinique",
        country_code: "MTQ",
        two_letter_country_code: "MQ",
    },
    {
        name: "Mauritius",
        code: "Mauritius",
        country_code: "MUS",
        two_letter_country_code: "MU",
    },
    {
        name: "Malawi",
        code: "Malawi",
        country_code: "MWI",
        two_letter_country_code: "MW",
    },
    {
        name: "Malaysia",
        code: "Malaysia",
        country_code: "MYS",
        two_letter_country_code: "MY",
    },
    {
        name: "Mayotte",
        code: "Mayotte",
        country_code: "MYT",
        two_letter_country_code: "YT",
    },
    {
        name: "Namibia",
        code: "Namibia",
        country_code: "NAM",
        two_letter_country_code: "NA",
    },
    {
        name: "New Caledonia",
        code: "New Caledonia",
        country_code: "NCL",
        two_letter_country_code: "NC",
    },
    {
        name: "Norfolk Island",
        code: "Norfolk Island",
        country_code: "NFK",
        two_letter_country_code: "NF",
    },
    {
        name: "Nigeria",
        code: "Nigeria",
        country_code: "NGA",
        two_letter_country_code: "NG",
    },
    {
        name: "Nicaragua",
        code: "Nicaragua",
        country_code: "NIC",
        two_letter_country_code: "NI",
    },
    {
        name: "Niue",
        code: "Niue",
        country_code: "NIU",
        two_letter_country_code: "NU",
    },
    {
        name: "Netherlands",
        code: "Netherlands",
        country_code: "NLD",
        two_letter_country_code: "NL",
    },
    {
        name: "Norway",
        code: "Norway",
        country_code: "NOR",
        two_letter_country_code: "NO",
    },
    {
        name: "Nepal",
        code: "Nepal",
        country_code: "NPL",
        two_letter_country_code: "NP",
    },
    {
        name: "Nauru",
        code: "Nauru",
        country_code: "NRU",
        two_letter_country_code: "NR",
    },
    {
        name: "New Zealand",
        code: "New Zealand",
        country_code: "NZL",
        two_letter_country_code: "NZ",
    },
    {
        name: "Oman",
        code: "Oman",
        country_code: "OMN",
        two_letter_country_code: "OM",
    },
    {
        name: "Pakistan",
        code: "Pakistan",
        country_code: "PAK",
        two_letter_country_code: "PK",
    },
    {
        name: "Panama",
        code: "Panama",
        country_code: "PAN",
        two_letter_country_code: "PA",
    },
    {
        name: "Pitcairn",
        code: "Pitcairn",
        country_code: "PCN",
        two_letter_country_code: "PN",
    },
    {
        name: "Peru",
        code: "Peru",
        country_code: "PER",
        two_letter_country_code: "PE",
    },
    {
        name: "Philippines",
        code: "Philippines",
        country_code: "PHL",
        two_letter_country_code: "PH",
    },
    {
        name: "Palau",
        code: "Palau",
        country_code: "PLW",
        two_letter_country_code: "PW",
    },
    {
        name: "Papua New Guinea",
        code: "Papua New Guinea",
        country_code: "PNG",
        two_letter_country_code: "PG",
    },
    {
        name: "Poland",
        code: "Poland",
        country_code: "POL",
        two_letter_country_code: "PL",
    },
    {
        name: "Puerto Rico",
        code: "Puerto Rico",
        country_code: "PRI",
        two_letter_country_code: "PR",
    },
    {
        name: "Portugal",
        code: "Portugal",
        country_code: "PRT",
        two_letter_country_code: "PT",
    },
    {
        name: "Paraguay",
        code: "Paraguay",
        country_code: "PRY",
        two_letter_country_code: "PY",
    },
    {
        name: "Palestinian Territory, Occupied",
        code: "Palestinian Territory, Occupied",
        country_code: "PSE",
        two_letter_country_code: "PS",
    },
    {
        name: "French Polynesia",
        code: "French Polynesia",
        country_code: "PYF",
        two_letter_country_code: "PF",
    },
    {
        name: "Qatar",
        code: "Qatar",
        country_code: "QAT",
        two_letter_country_code: "QA",
    },
    {
        name: "Réunion",
        code: "Réunion",
        country_code: "REU",
        two_letter_country_code: "RE",
    },
    {
        name: "Romania",
        code: "Romania",
        country_code: "ROU",
        two_letter_country_code: "RO",
    },
    {
        name: "Russia",
        code: "Russia",
        country_code: "RUS",
        two_letter_country_code: "RU",
    },
    {
        name: "Rwanda",
        code: "Rwanda",
        country_code: "RWA",
        two_letter_country_code: "RW",
    },
    {
        name: "Saudi Arabia",
        code: "Saudi Arabia",
        country_code: "SAU",
        two_letter_country_code: "SA",
    },
    {
        name: "Senegal",
        code: "Senegal",
        country_code: "SEN",
        two_letter_country_code: "SN",
    },
    {
        name: "Singapore",
        code: "Singapore",
        country_code: "SGP",
        two_letter_country_code: "SG",
    },
    {
        name: "South Georgia and the South Sandwich Islands",
        code: "South Georgia and the South Sandwich Islands",
        country_code: "SGS",
        two_letter_country_code: "GS",
    },
    {
        name: "Saint Helena, Ascension and Tristan da Cunha",
        code: "Saint Helena, Ascension and Tristan da Cunha",
        country_code: "SHN",
        two_letter_country_code: "SH",
    },
    {
        name: "Solomon Islands",
        code: "Solomon Islands",
        country_code: "SLB",
        two_letter_country_code: "SB",
    },
    {
        name: "Sierra Leone",
        code: "Sierra Leone",
        country_code: "SLE",
        two_letter_country_code: "SL",
    },
    {
        name: "El Salvador",
        code: "El Salvador",
        country_code: "SLV",
        two_letter_country_code: "SV",
    },
    {
        name: "San Marino",
        code: "San Marino",
        country_code: "SMR",
        two_letter_country_code: "SM",
    },
    {
        name: "Saint Pierre and Miquelon",
        code: "Saint Pierre and Miquelon",
        country_code: "SPM",
        two_letter_country_code: "PM",
    },
    {
        name: "Serbia",
        code: "Serbia",
        country_code: "SRB",
        two_letter_country_code: "RS",
    },
    {
        name: "Sao Tome and Principe",
        code: "Sao Tome and Principe",
        country_code: "STP",
        two_letter_country_code: "ST",
    },
    {
        name: "Suriname",
        code: "Suriname",
        country_code: "SUR",
        two_letter_country_code: "SR",
    },
    {
        name: "Slovakia",
        code: "Slovakia",
        country_code: "SVK",
        two_letter_country_code: "SK",
    },
    {
        name: "Slovenia",
        code: "Slovenia",
        country_code: "SVN",
        two_letter_country_code: "SI",
    },
    {
        name: "Sweden",
        code: "Sweden",
        country_code: "SWE",
        two_letter_country_code: "SE",
    },
    {
        name: "Swaziland",
        code: "Swaziland",
        country_code: "SWZ",
        two_letter_country_code: "SZ",
    },
    {
        name: "Seychelles",
        code: "Seychelles",
        country_code: "SYC",
        two_letter_country_code: "SC",
    },
    {
        name: "Turks and Caicos Islands",
        code: "Turks and Caicos Islands",
        country_code: "TCA",
        two_letter_country_code: "TC",
    },
    {
        name: "Togo",
        code: "Togo",
        country_code: "TGO",
        two_letter_country_code: "TG",
    },
    {
        name: "Thailand",
        code: "Thailand",
        country_code: "THA",
        two_letter_country_code: "TH",
    },
    {
        name: "Tajikistan",
        code: "Tajikistan",
        country_code: "TJK",
        two_letter_country_code: "TJ",
    },
    {
        name: "Tokelau",
        code: "Tokelau",
        country_code: "TKL",
        two_letter_country_code: "TK",
    },
    {
        name: "Turkmenistan",
        code: "Turkmenistan",
        country_code: "TKM",
        two_letter_country_code: "TM",
    },
    {
        name: "Timor-Leste",
        code: "Timor-Leste",
        country_code: "TLS",
        two_letter_country_code: "TL",
    },
    {
        name: "Tonga",
        code: "Tonga",
        country_code: "TON",
        two_letter_country_code: "TO",
    },
    {
        name: "Trinidad and Tobago",
        code: "Trinidad and Tobago",
        country_code: "TTO",
        two_letter_country_code: "TT",
    },
    {
        name: "Tunisia",
        code: "Tunisia",
        country_code: "TUN",
        two_letter_country_code: "TN",
    },
    {
        name: "Turkey",
        code: "Turkey",
        country_code: "TUR",
        two_letter_country_code: "TR",
    },
    {
        name: "Tuvalu",
        code: "Tuvalu",
        country_code: "TUV",
        two_letter_country_code: "TV",
    },
    {
        name: "Taiwan",
        code: "Taiwan",
        country_code: "TWN",
        two_letter_country_code: "TW",
    },
    {
        name: "Tanzania",
        code: "Tanzania",
        country_code: "TZA",
        two_letter_country_code: "TZ",
    },
    {
        name: "Uganda",
        code: "Uganda",
        country_code: "UGA",
        two_letter_country_code: "UG",
    },
    {
        name: "United States Minor Outlying Islands",
        code: "United States Minor Outlying Islands",
        country_code: "UMI",
        two_letter_country_code: "UM",
    },
    {
        name: "Uruguay",
        code: "Uruguay",
        country_code: "URY",
        two_letter_country_code: "UY",
    },
    {
        name: "United States",
        code: "United States",
        country_code: "USA",
        two_letter_country_code: "US",
    },
    {
        name: "Uzbekistan",
        code: "Uzbekistan",
        country_code: "UZB",
        two_letter_country_code: "UZ",
    },
    {
        name: "Holy See (Vatican City State)",
        code: "Holy See (Vatican City State)",
        country_code: "VAT",
        two_letter_country_code: "VA",
    },
    {
        name: "Saint Vincent and the Grenadines",
        code: "Saint Vincent and the Grenadines",
        country_code: "VCT",
        two_letter_country_code: "VC",
    },
    {
        name: "Virgin Islands, British",
        code: "Virgin Islands, British",
        country_code: "VGB",
        two_letter_country_code: "VG",
    },
    {
        name: "Virgin Islands, U.S.",
        code: "Virgin Islands, U.S.",
        country_code: "VIR",
        two_letter_country_code: "VI",
    },
    {
        name: "Vietnam",
        code: "Viet Nam",
        country_code: "VNM",
        two_letter_country_code: "VN",
    },
    {
        name: "Vanuatu",
        code: "Vanuatu",
        country_code: "VUT",
        two_letter_country_code: "VU",
    },
    {
        name: "Wallis and Futuna",
        code: "Wallis and Futuna",
        country_code: "WLF",
        two_letter_country_code: "WF",
    },
    {
        name: "Samoa",
        code: "Samoa",
        country_code: "WSM",
        two_letter_country_code: "WS",
    },
    {
        name: "South Africa",
        code: "South Africa",
        country_code: "ZAF",
        two_letter_country_code: "ZA",
    },
    {
        name: "Zambia",
        code: "Zambia",
        country_code: "ZMB",
        two_letter_country_code: "ZM",
    },
    {
        name: "Zimbabwe",
        code: "Zimbabwe",
        country_code: "ZWE",
        two_letter_country_code: "ZW",
    },
    {
        name: "Bali",
        code: "Bali",
        country_code: "BAL",
        two_letter_country_code: "ID",
    },
    {
        name: "Tahiti",
        code: "Tahiti",
        country_code: "TAH",
        two_letter_country_code: "PF",
    },
    {
        name: "Antarctic Flyover",
        code: "Antarctic Flyover",
        country_code: "ANF",
        two_letter_country_code: "AU",
    },
    {
        name: "Caroline Islands",
        code: "Caroline Islands",
        country_code: "CAI",
        two_letter_country_code: "FM",
    },
    {
        name: "Bonaire, Sint Eustatius and Saba",
        code: "Bonaire, Sint Eustatius and Saba",
        country_code: "BES",
        two_letter_country_code: "BQ",
    },
    {
        name: "Curacao",
        code: "Curacao",
        country_code: "CUW",
        two_letter_country_code: "CW",
    },
    {
        name: "Sint Maarten",
        code: "Sint Maarten",
        country_code: "SXM",
        two_letter_country_code: "SX",
    },
    {
        name: "Arctic Circle",
        code: "Worldwide (Arctic Circle)",
        country_code: "ARC",
        two_letter_country_code: "US",
    },
    {
        name: "Caribbean Islands",
        code: "Caribbean Cruise",
        country_code: "CBI",
        two_letter_country_code: "US",
    },
    {
        name: "Hawaiian Islands",
        code: "United States (Hawaii)",
        country_code: "HI",
        two_letter_country_code: "US",
    },
];
